

















































































































import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch
} from "@vue/composition-api";
import { useActions } from "vuex-composition-helpers";
import useFetcher from "@use/useFetcher";
import { useInputRules } from "@/ts/functions/composition/inputRules";
import TagsInput from "@c/molecules/tag/TagsInput.vue";
import ProjectModel from "@/ts/models/projectClass";
import CaldateInput from "@c/molecules/input/CaldateInput.vue";
import VisibilityInput from "@c/molecules/input/VisibilityInput.vue";
import ImageInput from "@c/molecules/media/ImageInput.vue";
import DeleteButton from "@c/atoms/app/DeleteButton.vue";
import PlaceChip from "@c/atoms/place/PlaceChip.vue";
import CudLayout from "@/vue/layouts/crud/CudLayout.vue";

export default defineComponent({
  name: "ProjectEdition",

  components: {
    TagsInput,
    ImageInput,
    CaldateInput,
    VisibilityInput,
    DeleteButton,
    PlaceChip,
    CudLayout
  },

  setup(props, { root }) {
    var form = ref(false);
    var loading_deletion = ref(false);
    var loading_edit = ref(false);

    const rules = useInputRules();

    const project_id = parseInt(root.$route.params.id);

    var { entity: project, loading } = useFetcher(
      "project/GET_PROJECT",
      {action_param:project_id,
      copy:true}
    );

    const { SEND_PROJECT_EDITION } = useActions({
      SEND_PROJECT_EDITION: "project/SEND_PROJECT_EDITION"
    } as any);
    const { SEND_PROJECT_DELETION } = useActions({
      SEND_PROJECT_DELETION: "project/SEND_PROJECT_DELETION"
    } as any);

    const editProject = () => {
      loading_edit.value = true;
      SEND_PROJECT_EDITION(project.value)
        .then(() => {
          loading_edit.value = false;
          root.$router.push("/project/" + project.value.id);
        })
        .catch(() => {
          loading_edit.value = false;
        });
    };

    const deleteProject = () => {
      loading_deletion.value = true;
      SEND_PROJECT_DELETION(project.value.id)
        .then(() => {
          loading_deletion.value = false;
          root.$router.push("/place/" + project.value.place_id);
        })
        .catch(() => {
          loading_deletion.value = false;
        });
    };

    return {
      loading,
      loading_edit,
      loading_deletion,
      rules,
      form,
      project,
      deleteProject,
      editProject
    };
  }
});
